import { Effect } from "react-notification-badge";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import PropType from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./style.module.scss";
import React, { useEffect, useState, useRef } from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import { database, storage } from "../../firebase";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import SenderInfo from "./mainComponent/sender/index";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import groupBy from "lodash.groupby";
import NotificationBadge from "react-notification-badge";
import AsideContacts from "../../components/AsideContacts";
import AsideNewFeed from "../../components/AsideNewFeed";

import "./media.css";

const firestore = firebase.firestore();

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  text: {
    top: "50px",
    position: "relative",
    left: "-50px",
  },
  cover: {
    width: 73,
    height: 73,
    borderRadius: "50%",
  },
}));

const Profile = ({ history }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [messages, SetMessages] = useState([]);
  const [searchStr, setSearchStr] = useState('')
  const dispatch = useDispatch();

  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
    creditzIds: state.profile.creditzIds,
  }));
  function getUserData(uid) {
    return new Promise((resolve, reject) => {
      return database.ref("users/" + uid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }

  let { id } = useParams();
  const dummy = useRef();
  var element = document.getElementsByClassName("chat-content clearfix");

  // height: "calc(100vh - 86.94px - 32px",
  const messagesRef = firestore
    .collection("messages")
    .doc(currentUser.uid)
    .collection(currentUser.uid + `-${id}`);
  const messagesRef2 = firestore
    .collection("messages")
    .doc(id)
    .collection(id + `-${currentUser.uid}`);
  const messageRef3 = firestore
    .collection("usermessages")
    .doc(id)
    .collection("messages");
  const messageRef4 = firestore
    .collection("usermessages")
    .doc(currentUser.uid)
    .collection("messages");
  const messageRefCount = firestore
    .collection("usermessages")
    .doc(currentUser.uid)
    .collection("messages");
  const query = messagesRef.orderBy("createdAt");
  const [writemessages] = useCollectionData(query, { idField: "id" });
  const query2 = messageRefCount.orderBy("createdAt");
  const [count] = useCollectionData(query2, { idField: "id" });
  const [leftside, setLeftside] = useState([]);
  const [unread, setUnread] = useState([]);

  async function updateRead(msg) {
    var batch = firestore.batch();
    let unreadArray = [];
    msg.message.forEach(async (message) => {
      if (message.isread === false) {
        if (msg.user_details.uid === message.senderid) {
          let ref = firestore
            .collection("usermessages")
            .doc(currentUser.uid)
            .collection("messages")
            .doc(message.id);
          batch.update(ref, "isread", true);
          message.isread = true;
        } else {
          if (
            unreadArray[message.senderid] &&
            unreadArray[message.senderid].length
          ) {
            unreadArray[message.senderid].push(message);
          } else {
            unreadArray[message.senderid] = [message];
          }
        }
      }
    });
    setUnread((oldValues) => [...unreadArray]);
    batch.commit();
  }
  async function Counting() {
    var group = groupBy(count, function (b) {
      return b.senderid;
    });
    const groups = Object.values(group);

    const arrs = groups.map((users) => {
      return users;
    });
      var newRes = await Promise.all(
      arrs.map(async (user, i) => {
        const data = await getUserData(user[0].senderid);
        return { message: user, user_details: data };
      })
);
    newRes.sort(function (x, y) {
      return (
        y.message[y.message.length - 1].timestamp -
        x.message[x.message.length - 1].timestamp
      );
    });
    let readArray = [];
    var batch = firestore.batch();
    newRes.forEach((isread) => {
      isread.message.forEach((message) => {
        if (message.isread === false) {
          const key = message.senderid;
          if (
            readArray[key] &&
            readArray[key].length &&
            message.senderid !== id
          ) {
            readArray[key].push(message);
          } else {
            if (message.senderid !== id) {
              readArray[key] = [message];
            }
          }
          if (message.senderid === id) {
            let ref = firestore
              .collection("usermessages")
              .doc(currentUser.uid)
              .collection("messages")
              .doc(message.id);
            batch.update(ref, "isread", true);

            message.isread = true;
          }
        }
      });
    });
    setUnread(readArray);
    batch.commit();
    setLeftside(newRes);
  }

  function updateNotifications() {
    return database
      .ref(`/Notifications`)
      .child(currentUser.uid)
      .orderByChild("type")
      .equalTo("Message")
      .once("value")
      .then(async (snapshot) => {
        const array = [];
        snapshot.forEach((childSnapshot) => {
          array.push(childSnapshot.val());
        });
        array.forEach(async (notification) => {
          const updates = {};
          const updates2 = {};
          updates[
            `/Notifications/${currentUser.uid}/${notification.messagekey}/isread`
          ] = "true";
          updates2[
            `/Notifications/${currentUser.uid}/${notification.messagekey}/isDeleted`
          ] = "true";
          if (notification.sender === id) {
            await database
              .ref()
              .update(updates)
              .then(() => {});
            await database.ref().update(updates2);
          }
        });

      });
  }

  const [formValue, setFormValue] = useState("");
  const sendMessage = async (e) => {
    // e.preventDefault();

    // const { uid } = currentUser.uid;
    // const { photoURL } = ;
    let photo =
      "https://firebasestorage.googleapis.com/v0/b/creditzmusic.appspot.com/o/profile_images%2F3oq0ASSPykeBWp4OVpYlR2uXwYe2?alt=media&token=dcb88f23-1c71-42e3-b932-5d864338dfb2";
    await messagesRef
      .add({
        text: formValue,
        user: currentUser.uid,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        // name: currentUser.fullName,
        photoURL: currentUser.profileImageUrl,
        receiver: id,
        id: id,
        timestamp: moment().toDate().getTime(),
      })
      .then((Snapshot) => {
        messagesRef2.doc(Snapshot.id).set({
          text: formValue,
          user: currentUser.uid,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          // name: currentUser.fullName,
          photoURL: currentUser.profileImageUrl,
          receiver: id,
          id: currentUser.uid,
          timestamp: moment().toDate().getTime(),
          isread: "false",
        });
        messageRef3.add({
          text: formValue,
          user: currentUser.uid,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          receiver: id,
          senderid: currentUser.uid,
          timestamp: moment().toDate().getTime(),
          isread: false,
        });

        messageRef4.add({
          text: formValue,
          user: currentUser.uid,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          receiver: id,
          senderid: id,
          timestamp: moment().toDate().getTime(),
          isread: true,
        });

        database.ref("Notifications/").child(id).child(Snapshot.id).set({
          sender: currentUser.uid,
          type: "Message",
          timestamp: moment().toDate().getTime(),
          isDeleted: "false",
          isread: "false",
          text: formValue,
          messagekey: Snapshot.id,
        });
      });

    setFormValue("");
  };

  const _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  const _handleClick = () => {
    sendMessage();
  };

  useEffect(() => {
    dummy.current.scrollIntoView({ behavior: "smooth" });
  }, [writemessages]);

  useEffect(() => {}, []);
  useEffect(() => {
    setTimeout(() => {
      Counting();
    }, 300);
  }, [count]);
  useEffect(() => {
    updateNotifications();
  });
  return (
    <>
      {loading == true ? (
        <Loader />
        ) : (
          <div>
          <Row>
          <Col xs={2}>

          <AsideNewFeed></AsideNewFeed>
          </Col>
            <Col md={2} xm={12}>
              <div className={styles.leftSideComponent}>
               
                <div className={styles.thumb}>
                 
                </div>
                <div className={styles.infoContainer}>
                  <div className={styles.messageContainer}>
                    <div className={styles.title} style={{justifyContent:"center"}}>
                      <div>
                      <input 
                        type="text" id="ip2" placeholder='Search' 
                        value={searchStr}
                        onChange={(e)=>{
                          setSearchStr(e.target.value)
                        }}
                      />

                      </div>
                    </div>
                    <hr className={styles.hr} />
                    <div className={styles.root}>
                      {" "}
                      {leftside.length<=0?"You Dont Have Messages":
                      
                      leftside &&
                        leftside
                        .filter(obj => {
                    
                          const str = searchStr.toLowerCase();
                          const firstName = obj.user_details.firstName.toLowerCase() || ''
                          const fullName = obj.user_details.fullName.toLowerCase() || ''
                          
                          return fullName.includes(str) || firstName.includes(str)
                        })
                        .map((msg, index) => (
                          <div key={index} onClick={() => updateRead(msg)}>
                            <Link to={`/Messages/${msg.message[0].senderid}`}>
                              {unread && unread[msg.user_details?.uid] ? (
                                <NotificationBadge
                                  count={unread[msg.user_details?.uid].length}
                                  effect={Effect.SCALE}
                                />
                              ) : (
                                ""
                              )}
                              <div className={styles.messageContainer}>
                                <div className={styles.avatarsContainer}>
                                  <img
                                    src={msg.user_details?.profileImageUrl}
                                    alt={"image-avatar"}
                                  />{" "}
                                </div>{" "}
                                <div className={styles.message}>
                                  <div className={styles.sender}>
                                    {" "}
                                    {msg.user_details?.fullName}{" "}
                                  </div>{" "}
                                  <div className={styles.content}>
                                    {msg.message[msg.message.length - 1].user ==
                                    currentUser.uid
                                      ? `you:${
                                          msg.message[msg.message.length - 1]
                                            .text
                                        }`
                                      : msg.message[msg.message.length - 1]
                                          .text}{" "}
                                  </div>{" "}
                                </div>{" "}
                                <div className={styles.time}>
                                  {" "}
                                  {moment(
                                    msg.message[msg.message.length - 1]
                                      .timestamp
                                  ).fromNow()}{" "}
                                </div>{" "}
                              </div>{" "}
                            </Link>
                            <hr className={styles.hr} />{" "}
                          </div>
                        ))
                      }
                    
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={6} sm={12} style={{paddingTop:"25px"}}>
              <Row>
              </Row>

              <div className="middle-box">
                <div className="row">
                  <div className="col-sm-12 mb-3">
                    <div className="card border-0 rounded-xl shadow-xs">
                    <SenderInfo></SenderInfo>
                      <div
                        className="card-body p-sm-4"
                        style={{
                          // height: "calc(100vh - 86.94px - 32px",
                          overflow: "hidden",
                        }}
                      >
                        <div className="chat-container">
                          {/* <div className="chat-content clearfix"> */}

                          <main>
                            {writemessages &&
                              writemessages.map((msg) => (
                                <ChatMessage key={msg.id} message={msg} />
                              ))}
                            {<span ref={dummy}></span>}
                          </main>

                          {/* </div> */}

                          {id === "new" ? (
                            ""
                          ) : (
                            <div className="chat-footer d-flex">
                              <button className="btn btn-light mmwh-50 border rounded-pill me-2 text-primary">
                                <svg className="icon icon-8x">
                                  <use href="#icon_mic"></use>
                                </svg>
                              </button>

                              <input
                                type="text"
                                value={formValue}
                                onChange={(e) => setFormValue(e.target.value)}
                                className="form-control form-control-lg"
                                placeholder="Start typing..."
                                onKeyDown={_handleKeyDown}
                              />

                              <button
                                className="btn btn-primary mmwh-50 border-0 rounded-pill ms-2"
                                disabled={!formValue}
                                onClick={_handleClick}
                                //   // handleClick()
                                // }
                              >
                                <svg className="icon icon-6x">
                                  <use href="#icon_send"></use>
                                </svg>
                              </button>
                            </div>
                          )}
                          {/* < MessageCard ref={ref}/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={2}>
              {" "}
              <AsideContacts></AsideContacts>{" "}
            </Col>
          </Row>

          {/* </Row> */}
        </div>
      )}
      {/* <Backdrop className={classes.backdrop} open={false}>
        <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
      </Backdrop> */}
    </>
  );
};
function ChatMessage(props) {
  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));

  const { text, uid, photoURL, user, createdAt, name, timestamp } =
    props.message;

  const messageClass = uid === currentUser.uid ? "sent" : "received";

  return (
    <>
      <div
        className={
          user == currentUser.uid
            ? "float-end w-75 my-2 text-end"
            : "float-start w-75 my-2"
        }
      >
        <div className="d-inline-flex align-items-center mb-2 text-start">
          <img src={photoURL} className="mmwh-40 rounded-pill" alt="avatar" />
          <div className="ms-2">
            <h6 className="fw-bold fs-14 mb-0">{name}</h6>
            <small className="text-muted fs-12 fw-medium">
              {moment(timestamp).format("hh:mm a")}
            </small>
          </div>
        </div>
        <div
          className={
            user == currentUser.uid ? "reply-bubble" : "recieve-bubble"
          }
        >
          <span>{text}</span>
        </div>
      </div>
    </>
  );
}

Profile.propTypes = {
  history: PropType.object,
};

export default withRouter(Profile);
